import * as Start from "../style/intro-style";
import { IntroAnimation } from "../gsap/introAnimation";


export const IntroHeader: React.FC = () => {
	return (

			<Start.IntroContainer>
				<Start.ColumnContainer>
					<IntroAnimation />
				</Start.ColumnContainer>
				<Start.DownArrow />

			</Start.IntroContainer>
	
	)
};